<template>
    <div v-if="show" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="nevs-popup-text">{{ $LANG.Get('alerts.cancelledInvoiceMembershipsQuestion') }}</div>
            <div class="membership-list">
                <div v-for="row in rows" :key="row.id" class="membership-row">
                    <NevsCheckbox v-model="row.selected" :label="row.person_name"></NevsCheckbox>
                    <div class="membership-details">
                        {{ row.membership_name }} ({{ row.start_date_display }} - {{ row.end_date_display }})
                    </div>
                </div>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="primary" @click="skipClick()">
                    <i class="fa-solid fa-xmark"></i>
                    {{ $LANG.Get('buttons.skip') }}
                </NevsButton>
                <NevsButton class="error" @click="deleteClick()">
                    <i class="fa-solid fa-trash"></i>
                    {{ $LANG.Get('buttons.delete') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "ModalCancelledMemberships",
    components: {NevsCheckbox, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        // The memberships the cancelled invoice had assigned, as returned by invoices/cancel.
        personMemberships: {
            type: Array,
            default: () => []
        }
    },
    emits: ['done'],
    data() {
        return {
            rows: []
        }
    },
    watch: {
        show() {
            if (!this.show) {
                return;
            }
            // The invoice is already cancelled by the time this opens, so deleting what it assigned is the
            // expected follow-up - everything starts ticked and the user unticks what should stay.
            this.rows = this.personMemberships.map((personMembership) => {
                return {...personMembership, selected: true};
            });
        }
    },
    methods: {
        skipClick() {
            this.$emit('done');
        },
        deleteClick() {
            let ids = this.rows.filter((row) => row.selected).map((row) => row.id);
            if (ids.length === 0) {
                this.$emit('done');
                return;
            }

            let vm = this;
            this.$API.APICall('post', 'person-memberships/delete-multiple', {ids: ids}, (data, success) => {
                if (success) {
                    vm.$emit('done');
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.nevs-popup {
    max-width: 500px;
}

.membership-list {
    padding: 0 20px;
}

.membership-row {
    padding: 8px 0;
    border-top: 1px solid rgba(128, 128, 128, 0.25);
}

/* The membership itself is a detail of the person named on the checkbox, so it is indented under the label
   rather than aligned with the box. */
.membership-details {
    margin-left: 30px;
    font-size: 0.85em;
    color: #888;
}
</style>
